import { ErrorState } from '@/shared/ui/states/ErrorState';

export function RouteError() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <ErrorState
        title="Не удалось открыть страницу"
        description="Возможно, сервис обновился или пропало соединение. Обновите страницу и попробуйте снова."
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
